var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { display, alignItems, position, top, space, justifyContent, backgroundColor, boxShadow, fontSize, width, border, } from 'styled-system';
import { themeHeight, themeWidth, themeMaxWidth, themeMaxHeight, } from '../../common/theme/theme';
import Drawer from '../../common/components/Drawer';
import RichTextBlock from '../../common/components/RichText';
import SwipeListener from '../../common/components/SwipeListener';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import { LocaleConsumer } from '../../common/providers/LocaleProvider';
import arrowLeft from '../../common/assets/icons/arrow-left.svg';
var Header = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n"])), display, alignItems, position, top, space, fontSize, themeHeight, width, justifyContent, backgroundColor, boxShadow, border);
Header.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    px: [3, 4, null, 5],
    fontSize: [4, null, null, 5],
    themeHeight: ['54px', 7],
    width: 1,
    justifyContent: 'left',
    backgroundColor: 'white',
    boxShadow: 'bottom',
    border: 'none',
};
var ArrowLeft = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), themeWidth, themeMaxWidth, themeHeight, themeMaxHeight);
ArrowLeft.defaultProps = {
    src: arrowLeft,
    themeWidth: 5,
    themeMaxWidth: 5,
    themeHeight: 5,
    themeMaxHeight: 5,
};
var StyledRichTextBlock = styled(RichTextBlock)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  p {\n    ", ";\n  }\n"], ["\n  ", ";\n  p {\n    ", ";\n  }\n"])), space, fontSize);
StyledRichTextBlock.defaultProps = {
    p: [3, 4, null, 5],
    fontSize: [3, null, 4, 5],
};
var CLOSE_DISCLAIMER_EVENT = {
    open: false,
    shouldAutoplay: true,
    lockScroll: false,
};
var CommonDisclaimer = function () { return (React.createElement(DisclaimerSubscription, null, function (_a) {
    var value = _a.value, emit = _a.emit;
    return (React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(SwipeListener, { onSwipeRight: function () { return emit(__assign({}, value, CLOSE_DISCLAIMER_EVENT)); } },
        React.createElement(Drawer, { isOpen: value.open, onBackdropClick: function () {
                return emit(__assign({}, value, CLOSE_DISCLAIMER_EVENT));
            } },
            React.createElement(Header, { onClick: function () { return emit(__assign({}, value, CLOSE_DISCLAIMER_EVENT)); } },
                React.createElement(ArrowLeft, null),
                l10n.t('h24_go_back')),
            React.createElement(StyledRichTextBlock, { dangerouslySetInnerHTML: { __html: value.html }, "data-testid": "html" })))); }));
})); };
export default CommonDisclaimer;
var templateObject_1, templateObject_2, templateObject_3;
